import React from 'react';
import { SkeletonBlock } from '../../../components/skeleton/skeleton';

// Admin referral sayfasının ilk paint iskeleti: header + sekme + filtre + tablo.
const ReferralAdminSkeleton = () => (
  <div className="min-h-[calc(100vh-4rem)] bg-white px-4 py-6 dark:bg-slate-900/40 sm:px-6 lg:px-8 lg:py-8">
    <div className="mx-auto max-w-6xl space-y-6">
      <div className="space-y-2">
        <SkeletonBlock className="h-7 w-48" />
        <SkeletonBlock className="h-4 w-80 max-w-full" />
      </div>

      <SkeletonBlock className="h-10 w-56 !rounded-md" />

      <div className="flex gap-3">
        <SkeletonBlock className="h-10 w-44 !rounded-md" />
        <SkeletonBlock className="h-10 w-32 !rounded-md" />
      </div>

      <div className="overflow-hidden rounded-md border border-slate-200 dark:border-slate-700">
        <table className="w-full">
          <thead className="bg-slate-50 dark:bg-slate-800/70">
            <tr>
              {Array.from({ length: 7 }).map((_, i) => (
                <th key={i} className="px-4 py-3 text-left">
                  <SkeletonBlock className="h-3 w-16" />
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: 6 }).map((_, r) => (
              <tr
                key={r}
                className="border-b border-slate-100 dark:border-slate-700/60"
              >
                {Array.from({ length: 7 }).map((_, c) => (
                  <td key={c} className="px-4 py-3">
                    <SkeletonBlock className="h-4 w-16" />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
);

export default ReferralAdminSkeleton;
